import React, { useState, useEffect } from 'react';
import { 
  ShieldCheck, 
  ArrowLeft, 
  Search, 
  Moon, 
  Sun, 
  FileText, 
  UserCheck, 
  Lock, 
  AlertTriangle, 
  HelpCircle, 
  CheckCircle2,
  BookOpen,
  Scale,
  RefreshCw,
  Mail,
  ChevronRight,
  Menu,
  X
} from 'lucide-react';

export const TerminosServicio = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeSection, setActiveSection] = useState('aceptacion');
  const [accepted, setAccepted] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Toggle dark mode class on document root or body wrapper
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  // Sections data for navigation and search
  const sections = [
    {
      id: 'aceptacion',
      title: '1. Aceptación de los Términos',
      icon: <CheckCircle2 className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Al acceder, registrarse o utilizar la plataforma de Consultorio Digital (en adelante, "la Aplicación", "el Sistema" o "el Servicio"), usted manifiesta su lectura, comprensión y aceptación expresa de los presentes Términos de Servicio y de nuestra Política de Privacidad. Estos términos constituyen un contrato vinculante entre usted (ya sea como profesional de la salud, personal administrativo o paciente) y Consultorio Digital S.A. de C.V. Si no está de acuerdo con la totalidad de estos términos, deberá abstenerse de utilizar la plataforma y sus servicios asociados.`
    },
    {
      id: 'descripcion',
      title: '2. Descripción del Servicio',
      icon: <BookOpen className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Consultorio Digital es una plataforma tecnológica integral diseñada para la gestión de consultorios médicos, clínicas y centros de salud. El servicio incluye herramientas para la administración de expedientes clínicos electrónicos (ECE), programación de citas médicas, almacenamiento de historiales clínicos, recetas electrónicas y gestión de facturación o cobros. La plataforma actúa como un proveedor de software como servicio (SaaS) y facilitador tecnológico, sin intervenir directamente en la relación médico-paciente ni emitir diagnósticos o tratamientos médicos.`
    },
    {
      id: 'registro',
      title: '3. Registro y Cuentas de Usuario',
      icon: <UserCheck className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Para utilizar ciertas funcionalidades del Servicio, es obligatorio crear una cuenta de usuario. Existen tres perfiles principales: (a) Médicos / Profesionales de la Salud, quienes deben garantizar contar con título y cédula profesional vigentes; (b) Personal Administrativo, autorizado por el profesional médico o clínica; y (c) Pacientes. Usted es el único responsable de mantener la confidencialidad de sus credenciales de acceso (nombre de usuario y contraseña) y de todas las actividades que ocurran bajo su cuenta. Cualquier uso no autorizado debe ser reportado inmediatamente a nuestro equipo de soporte.`
    },
    {
      id: 'privacidad',
      title: '4. Privacidad y Protección de Datos de Salud',
      icon: <Lock className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `La protección de los datos personales y, en particular, de los datos sensibles de salud, es nuestra máxima prioridad. Consultorio Digital opera en cumplimiento con las normativas vigentes en materia de protección de datos personales y los estándares técnicos de expedientes clínicos electrónicos (como la NOM-024-SSA3-2012 y regulaciones análogas aplicables). Los datos médicos ingresados son considerados estrictamente confidenciales y están protegidos bajo el secreto médico y altos estándares de cifrado en tránsito y reposo. Nosotros no comercializamos ni compartimos expedientes clínicos con terceros no autorizados.`
    },
    {
      id: 'uso-adecuado',
      title: '5. Uso Adecuado y Restricciones',
      icon: <ShieldCheck className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `El usuario se compromete a utilizar la plataforma exclusivamente para fines lícitos y médicos profesionales. Queda estrictamente prohibido: (a) introducir información falsa, suplantar la identidad de otro profesional o paciente; (b) intentar vulnerar la seguridad de los servidores, realizar ingeniería inversa o ataques de denegación de servicio; (c) utilizar el sistema para almacenar material ilícito, difamatorio o violatorio de derechos de autor; y (d) extraer de forma masiva datos de la plataforma mediante bots o scripts automatizados.`
    },
    {
      id: 'propiedad',
      title: '6. Propiedad Intelectual',
      icon: <Scale className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Todos los derechos de propiedad intelectual sobre el software Consultorio Digital, su diseño gráfico, código fuente, logotipos, marcas, interfaces y documentación asociada son propiedad exclusiva de Consultorio Digital S.A. de C.V. Se concede al usuario una licencia limitada, no exclusiva, intransferible y revocable para utilizar la plataforma conforme a su suscripción. Ninguna disposición de estos términos otorga al usuario derecho alguno sobre las marcas registradas o la propiedad intelectual de la empresa.`
    },
    {
      id: 'limitacion',
      title: '7. Limitación de Responsabilidad',
      icon: <AlertTriangle className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Consultorio Digital es una herramienta tecnológica de apoyo administrativo y clínico. La plataforma NO sustituye bajo ninguna circunstancia el criterio, diagnóstico, prescripción ni la responsabilidad profesional del médico tratante. La empresa no se hace responsable por errores de diagnóstico, omisiones en el expediente introducidas por los usuarios, ni por interrupciones temporales del servicio debidas a fallas de internet o mantenimientos programados. El uso del sistema y las decisiones clínicas recaen única y exclusivamente en el profesional de la salud.`
    },
    {
      id: 'modificaciones',
      title: '8. Modificaciones a los Términos',
      icon: <RefreshCw className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Nos reservamos el derecho de modificar o actualizar estos Términos de Servicio en cualquier momento para reflejar cambios en nuestras funcionalidades, normativas legales o estándares de seguridad. Las modificaciones sustanciales serán notificadas a través de un aviso destacado en la plataforma o mediante correo electrónico registrado. El uso continuado del servicio tras la publicación de los nuevos términos constituirá su aceptación incondicional a las modificaciones introducidas.`
    },
    {
      id: 'contacto',
      title: '9. Contacto y Soporte',
      icon: <HelpCircle className="w-5 h-5 text-teal-600 dark:text-teal-400" />,
      content: `Para cualquier duda, aclaración, reporte de incidentes de seguridad o ejercicio de derechos relacionados con estos Términos de Servicio, nuestro equipo de soporte legal y técnico está a su disposición en el correo electrónico legal@consultoriodigital.com, o bien a través del centro de ayuda integrado en el panel de control de su cuenta.`
    }
  ];

  // Filter sections based on search term
  const filteredSections = sections.filter(sec => 
    sec.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
    sec.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`min-h-screen font-sans transition-colors duration-300 ${darkMode ? 'bg-slate-900 text-slate-100' : 'bg-slate-50 text-slate-800'}`}>
      
      {}
      <header className={`sticky top-0 z-50 backdrop-blur-md border-b transition-colors ${darkMode ? 'bg-slate-900/90 border-slate-800' : 'bg-white/90 border-slate-200'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button 
              onClick={() => alert("Redirigiendo a la página principal...")}
              className={`p-2 rounded-lg transition-colors flex items-center gap-2 text-sm font-medium ${darkMode ? 'hover:bg-slate-800 text-slate-300' : 'hover:bg-slate-100 text-slate-600'}`}
              title="Regresar"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Regresar</span>
            </button>
            <div className="flex items-center gap-3">
              <div className="bg-gradient-to-tr from-teal-600 to-blue-600 p-2 rounded-xl text-white shadow-md">
                <FileText className="w-6 h-6" />
              </div>
              <div>
                <span className="font-bold text-lg tracking-tight bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
                  Consultorio Digital
                </span>
                <span className={`block text-xs font-medium ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  Expediente Clínico & Gestión Médica
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            {/* Search Input */}
            <div className="relative hidden md:block w-64">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-slate-400">
                <Search className="w-4 h-4" />
              </span>
              <input
                type="text"
                placeholder="Buscar en los términos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={`w-full pl-9 pr-4 py-2 text-sm rounded-xl border transition-all outline-none focus:ring-2 focus:ring-teal-500 ${
                  darkMode 
                    ? 'bg-slate-800 border-slate-700 text-slate-200 placeholder-slate-400' 
                    : 'bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400'
                }`}
              />
            </div>

            {/* Dark Mode Toggle */}
            <button
              onClick={() => setDarkMode(!darkMode)}
              className={`p-2.5 rounded-xl border transition-colors ${
                darkMode ? 'bg-slate-800 border-slate-700 text-amber-400 hover:bg-slate-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-100'
              }`}
              title="Cambiar tema"
            >
              {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </button>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2.5 rounded-xl border md:hidden ${darkMode ? 'bg-slate-800 border-slate-700 text-slate-200' : 'bg-white border-slate-200 text-slate-700'}`}
            >
              {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile search bar */}
        <div className={`md:hidden px-4 pb-3 border-t ${darkMode ? 'border-slate-800 bg-slate-900' : 'border-slate-100 bg-white'}`}>
          <div className="relative mt-2">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-slate-400">
              <Search className="w-4 h-4" />
            </span>
            <input
              type="text"
              placeholder="Buscar en los términos..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`w-full pl-9 pr-4 py-2 text-sm rounded-xl border transition-all outline-none ${
                darkMode 
                  ? 'bg-slate-800 border-slate-700 text-slate-200 placeholder-slate-400' 
                  : 'bg-slate-50 border-slate-200 text-slate-800 placeholder-slate-400'
              }`}
            />
          </div>
        </div>
      </header>

      {}
      <div className={`border-b ${darkMode ? 'bg-slate-800/50 border-slate-800' : 'bg-teal-50/50 border-teal-100'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-teal-500/10 text-teal-600 dark:text-teal-400 mb-4 border border-teal-500/20">
              <ShieldCheck className="w-4 h-4" />
              Documento Legal Oficial
            </div>
            <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-4">
              Términos y Condiciones de Servicio
            </h1>
            <p className={`text-base sm:text-lg leading-relaxed mb-6 ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>
              Por favor lea detenidamente estos términos antes de utilizar nuestra plataforma de expediente clínico electrónico y gestión médica. Su uso implica la aceptación plena de los mismos.
            </p>
            <div className={`flex flex-wrap items-center gap-4 text-xs sm:text-sm font-medium ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
              <div className="flex items-center gap-1.5">
                <RefreshCw className="w-4 h-4 text-teal-600 dark:text-teal-400" />
                <span>Última actualización: 12 de Octubre, 2026</span>
              </div>
              <div className="hidden sm:inline text-slate-300 dark:text-slate-700">•</div>
              <div className="flex items-center gap-1.5">
                <Lock className="w-4 h-4 text-teal-600 dark:text-teal-400" />
                <span>Conforme a Normativa Sanitaria y NOM-024</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          
          {/* Sidebar Navigation */}
          <div className={`lg:col-span-1 ${isMobileMenuOpen ? 'block' : 'hidden lg:block'} mb-6 lg:mb-0`}>
            <div className={`sticky top-24 p-4 rounded-2xl border shadow-sm ${darkMode ? 'bg-slate-800/80 border-slate-700' : 'bg-white border-slate-200'}`}>
              <h3 className={`text-xs font-bold uppercase tracking-wider mb-3 px-3 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                Índice de Secciones
              </h3>
              <nav className="space-y-1">
                {sections.map((sec) => (
                  <button
                    key={sec.id}
                    onClick={() => {
                      setActiveSection(sec.id);
                      setIsMobileMenuOpen(false);
                      const el = document.getElementById(sec.id);
                      if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }}
                    className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all text-left ${
                      activeSection === sec.id
                        ? 'bg-teal-600 text-white shadow-md shadow-teal-600/20'
                        : darkMode 
                          ? 'text-slate-300 hover:bg-slate-700/60' 
                          : 'text-slate-600 hover:bg-slate-100'
                    }`}
                  >
                    <span className="truncate pr-2">{sec.title}</span>
                    <ChevronRight className={`w-4 h-4 flex-shrink-0 ${activeSection === sec.id ? 'text-white' : 'text-slate-400'}`} />
                  </button>
                ))}
              </nav>

              {/* Acceptance widget box inside sidebar */}
              <div className={`mt-6 p-4 rounded-xl border text-center ${darkMode ? 'bg-slate-900/50 border-slate-700' : 'bg-slate-50 border-slate-200'}`}>
                <h4 className="text-xs font-bold mb-2 uppercase tracking-wide">¿Acepta los términos?</h4>
                <p className={`text-xs mb-3 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  Confirme su conformidad para habilitar todas las funciones del sistema.
                </p>
                <button
                  onClick={() => setAccepted(!accepted)}
                  className={`w-full py-2.5 px-4 rounded-xl text-sm font-semibold transition-all flex items-center justify-center gap-2 shadow-sm ${
                    accepted
                      ? 'bg-emerald-600 hover:bg-emerald-700 text-white'
                      : 'bg-teal-600 hover:bg-teal-700 text-white'
                  }`}
                >
                  <CheckCircle2 className="w-4 h-4" />
                  {accepted ? 'Términos Aceptados' : 'Aceptar Términos'}
                </button>
                {accepted && (
                  <span className="block mt-2 text-xs text-emerald-500 font-medium animate-pulse">
                    ✓ Su confirmación ha sido guardada
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Content Area */}
          <div className="lg:col-span-3 space-y-8">
            {filteredSections.length === 0 ? (
              <div className={`p-12 text-center rounded-2xl border ${darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
                <Search className="w-12 h-12 mx-auto text-slate-400 mb-3" />
                <h3 className="text-lg font-bold mb-1">No se encontraron resultados</h3>
                <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                  No hay coincidencias para "{searchTerm}". Intente con otra palabra clave.
                </p>
              </div>
            ) : (
              filteredSections.map((sec) => (
                <section
                  key={sec.id}
                  id={sec.id}
                  className={`p-6 sm:p-8 rounded-2xl border transition-all ${
                    darkMode ? 'bg-slate-800/60 border-slate-700/80 shadow-lg shadow-black/20' : 'bg-white border-slate-200/80 shadow-sm'
                  }`}
                >
                  <div className="flex items-start gap-4">
                    <div className={`p-3 rounded-xl border flex-shrink-0 ${darkMode ? 'bg-slate-900/60 border-slate-700' : 'bg-teal-50 border-teal-100'}`}>
                      {sec.icon}
                    </div>
                    <div className="flex-1">
                      <h2 className="text-xl sm:text-2xl font-bold tracking-tight mb-4">
                        {sec.title}
                      </h2>
                      <p className={`text-base leading-relaxed whitespace-pre-line ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                        {sec.content}
                      </p>
                    </div>
                  </div>
                </section>
              ))
            )}

            {/* Bottom confirmation card */}
            <div className={`p-6 sm:p-8 rounded-2xl border bg-gradient-to-r ${
              darkMode ? 'from-teal-950/40 to-blue-950/40 border-teal-900/50' : 'from-teal-50 to-blue-50 border-teal-200'
            }`}>
              <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
                <div>
                  <h3 className="text-lg font-bold mb-1">¿Necesita asistencia adicional?</h3>
                  <p className={`text-sm ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>
                    Nuestro equipo legal y de soporte técnico está disponible para resolver cualquier consulta sobre nuestros términos.
                  </p>
                </div>
                <a
                  href="mailto:soporte@consultoriodigital.com"
                  className="flex items-center gap-2 px-5 py-3 rounded-xl bg-teal-600 hover:bg-teal-700 text-white font-semibold text-sm shadow-md transition-all flex-shrink-0"
                >
                  <Mail className="w-4 h-4" />
                  Contactar Soporte
                </a>
              </div>
            </div>

          </div>

        </div>
      </div>

      {}
      <footer className={`mt-20 border-t py-8 px-4 sm:px-6 lg:px-8 text-center text-sm ${darkMode ? 'bg-slate-900 border-slate-800 text-slate-400' : 'bg-white border-slate-200 text-slate-500'}`}>
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-bold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              Consultorio Digital
            </span>
            <span>© {new Date().getFullYear()} — Todos los derechos reservados.</span>
          </div>
          <div className="flex items-center space-x-6">
            <a href="#privacidad" className="hover:text-teal-600 transition-colors">Política de Privacidad</a>
            <a href="#contacto" className="hover:text-teal-600 transition-colors">Aviso Legal</a>
            <a href="#soporte" className="hover:text-teal-600 transition-colors">Seguridad NOM-024</a>
          </div>
        </div>
      </footer>

    </div>
  );
}